<template>
  <div v-if="Object.keys(allData).length">
    <div style="margin-top: 200px;" v-if="pathLogo == 'https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/'"></div>

    <div v-for="(item, i) in allData.items" :key="i" class="report-5" dir="rtl">
      <img v-if="i == 0" class="report-logo" src="/img/ns.png" alt="" />
      <section v-if="i == 0" class="header">
        <div class="one">
          <div>
            <p>المصرف :</p>
            <p>{{ allData.bankBranch }}</p>
          </div>
          <div>
            <p>نوع المعاملة :</p>
            <p>مرتبات الموظفين</p>
          </div>
        </div>
        <div class="three">
          <h2 class="text-center">شركة البرمجيات الدقيقة</h2>
          <h2 class="text-center">للحلول البرمجية وخدمات تقنية المعلومات</h2>
        </div>
        <div class="four">
          <h4>نموذج م ح / 13</h4>
          <h4>إستمارة رقم :</h4>
          <h4>تاريخ الطباعة : {{ date }}</h4>
          <h4>إستمارة صرف رواتب عن شهر : {{ month }}</h4>
        </div>
      </section>
      <section v-if="i == 0" class="sub-header">
        <p>المجموعة</p>
      </section>
      <section class="tables">
        <div v-if="i == 0" class="container-table-header">
          <div class="h111 head-grid">
            <div class="h1-t">الرقم المالى</div>
            <div class="h1-b">ر.م. المالية</div>
          </div>
          <div class="h222 head-grid">
            <div class="h2-t">الإسم</div>
            <div class="h2-b">رقم الحساب</div>
          </div>
          <div class="h333 head-grid">
            <div class="h3-t"></div>
            <div class="h3-b">عن شهر</div>
          </div>
          <div class="h444 head-grid">
            <div class="h4-t">الدرجة</div>
            <div class="h4-b">شهر العلاوة</div>
          </div>
          <div class="h555 head-grid">
            <div class="h5-t">الأساسى</div>
            <div class="h5-b">ندب</div>
          </div>
          <div class="h666 head-grid">
            <div class="h6-t">مكأفاءة</div>
            <div class="h6-b">الإجمالى</div>
          </div>
          <div class="h7 head-grid">
            <div class="h7-t">ضمان</div>
            <div class="h7-b">الدخل</div>
          </div>
          <div class="h8 head-grid">
            <div class="h8-t">الجهاد</div>
            <div class="h8-b">الدمغة</div>
          </div>
          <div class="h9 head-grid">
            <div class="h9-t">تضامن</div>
            <div class="h9-b">نفقة شرعية</div>
          </div>
          <div class="h10 head-grid">
            <div class="h10-t">ق.سلفة</div>
            <div class="h10-b">خصم أخرى</div>
          </div>
          <div class="h11 head-grid">
            <div class="h11-t">خ.عقوبة</div>
            <div class="h11-b">خ. غياب</div>
          </div>
          <div class="h12 head-grid">
            <div class="h12-t">علاوة بالصافى</div>
            <div class="h12-b">خصميات</div>
          </div>

          <div class="h14 head-grid">
            <div class="h14-t">علاوة لجنة</div>
            <div class="h14-b">العمل الاضافى</div>
          </div>
          <div v-if="false" class="h15 head-grid">
            <div class="h15-t-1">علاوة</div>
            <div class="h15-t-2">علاوة</div>
            <div class="h15-b-1">علاوة</div>
            <div class="h15-b-2">علاوة</div>
          </div>
          <div class="h13 head-grid">
            <div class="h13-t">صافى المرتبات</div>
            <div class="h13-b">الرقم الوطنى</div>
          </div>
        </div>

        <div class="container-table-body">
          <div class="b1 body-grid">
            <div class="b1-t">{{ item.financialNumber }}</div>
            <div class="b1-b">{{ item.fileNumber }}</div>
          </div>
          <div class="b2 body-grid">
            <div class="b2-t">{{ item.employeeName }}</div>
            <div class="b2-b">
              <div class="b2-b1">{{ item.accountNumber }}</div>
              <div class="b2-b2">{{ theMonth }}</div>
            </div>
          </div>
          <div class="b3 body-grid">
            <div class="b3-t">{{ item.degree }}</div>
            <div class="b3-b">{{ convert_Month(item.bonusDueDate) }}</div>
          </div>
          <div class="b4 body-grid">
            <div class="b4-t">{{ item.basicSalary }}</div>
            <div class="b4-b">0</div>
          </div>
          <div class="b5 body-grid">
            <div class="b5-t">{{ item.rewards }}</div>
            <div class="b5-b">{{ item.totalSalary }}</div>
          </div>
          <div class="b6 body-grid">
            <div class="b6-t">{{ item.warrantyTax }}</div>
            <div class="b6-b">0</div>
          </div>
          <div class="b7 body-grid">
            <div class="b7-t">{{ item.jihadTax }}</div>
            <div class="b7-b">{{ item.stampTax }}</div>
          </div>
          <div class="b8 body-grid">
            <div class="b8-t">{{ item.solidarityTax }}</div>
            <div class="b8-b">{{ item.legalExpenseDiscount }}</div>
          </div>
          <div class="b9 body-grid">
            <div class="b9-t">{{ item.creditDiscount }}</div>
            <div class="b9-b">{{ item.otherDiscounts }}</div>
          </div>
          <div class="b10 body-grid">
            <div class="b10-t">0</div>
            <div class="b10-b">{{ item.absanceDiscount }}</div>
          </div>
          <div class="b11 body-grid">
            <div class="b11-t">{{ item.totalAllowance }}</div>
            <div class="b11-b">{{ item.totalDiscount }}</div>
          </div>
          <div class="b13 body-grid">
            <div class="b13-t">{{ item.committeesAllownace }}</div>
            <div class="b13-b">{{ item.overTime }}</div>
          </div>
          <div v-if="false" class="b14 body-grid">
            <div class="b14-t1">0000</div>
            <div class="b14-t2">0000</div>
            <div class="b14-b1">0000</div>
            <div class="b14-b2">0000</div>
          </div>
          <div class="b12 body-grid">
            <div class="b12-t">{{ item.netSalary }}</div>
            <div class="b12-b">{{ item.nationalNumber }}</div>
          </div>
        </div>

        <div
          v-if="i + 1 == allData.items.length"
          class="container-table-footer"
        >
          <div class="f1 footer-grid">
            <div class="f1-1">الإجمالى</div>
            <div class="f1-2">
              <div class="f1-2t">عدد المرتبات</div>
              <div class="f1-2b">{{ allData.salariesCount }}</div>
            </div>
          </div>
          <div class="f2 footer-grid">
            <div class="f2-t">{{ allData.totalBasicSalaries }}</div>
            <div class="f2-b">0</div>
          </div>
          <div class="f3 footer-grid">
            <div class="f3-t">{{ allData.totalRewards }}</div>
            <div class="f3-b">{{ allData.totalSalaries }}</div>
          </div>
          <div class="f4 footer-grid">
            <div class="f4-t">{{ allData.totalWarrantyTax }}</div>
            <div class="f4-b">0</div>
          </div>
          <div class="f5 footer-grid">
            <div class="f5-t">{{ allData.totalJihadTax }}</div>
            <div class="f5-b">{{ allData.totalStampTax }}</div>
          </div>
          <div class="f6 footer-grid">
            <div class="f6-t">{{ allData.totalSolidarityTax }}</div>
            <div class="f6-b">{{ allData.totalLegalExpenseDiscount }}</div>
          </div>
          <div class="f7 footer-grid">
            <div class="f7-t">{{ allData.totalCreditDiscount }}</div>
            <div class="f7-b">{{ allData.totalOtherDiscounts }}</div>
          </div>
          <div class="f8 footer-grid">
            <div class="f8-t">0</div>
            <div class="f8-b">{{ allData.totalAbsanceDiscount }}</div>
          </div>
          <div class="f9 footer-grid">
            <div class="f9-t">{{ allData.totalAllowances }}</div>
            <div class="f9-b">{{ allData.totalDiscounts }}</div>
          </div>
          <div class="f11 footer-grid">
            <div class="f11-t">{{ allData.totalCommitteesAllownace }}</div>
            <div class="f11-b">{{ allData.totalOverTime }}</div>
          </div>
          <div v-if="false" class="f12 footer-grid">
            <div class="f12-t">0000</div>
            <div class="f12-b">0000</div>
          </div>
          <div v-if="false" class="f13 footer-grid">
            <div class="f13-t">0000</div>
            <div class="f13-b">00000</div>
          </div>
          <div class="f10 footer-grid">
            <div class="f10-t">{{ allData.totalNetSalaries }}</div>
            <div class="f10-b"></div>
          </div>
        </div>
      </section>
      <section v-if="i + 1 == allData.items.length" class="final-footer">
        <p>رئيس قسم الحسابات</p>
        <p>المراجعة الداخلية</p>
        <p>المراقب المالى</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: String,
    start: String,
    finish: String,
    name: String,
    desc: String,
    month: String,
    theMonth: String,
    allData: [Array, Object],
    pdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-5";
</style>
